module.exports = __webpack_public_path__ + "franchise-rainbow_six-desktop.png";